<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-12">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <div class="big-row">
              <div class="row">
                <div class="col-md-5">
                  <form-text label="Search Archived Workflow" name="searchworkflow" v-model="searchQuery"></form-text>
                </div>
              </div>
            </div>
            <br/>
            <data-table :data="filteredData" :columns="gridColumns" :filter-key="searchQuery"></data-table>
          </div>
        </div>
      </div><!-- /.col-md-8 -->
    </div>
  </div>
</template>

<script>
import DataTable from './ArchivedWorkflowTable'
import FormText from '../../elements/Form/FormText'
import database from '../../webmaster/Database/database'
import store from '../../webmaster/Store/vuex'

export default {
  name: 'workflows',
  components: {
    'data-table': DataTable,
    'form-text': FormText
  },
  data () {
    return {
      searchQuery: '',
      gridColumns: ['name', 'lastcompleted', 'nextdue', 'timeleft', 'more'],
      workflows: [],
      org: store.state.usermain,
      showArchived: false,
    }
  },
  created:function(){
    //Populate users
    var self = this
    var ref = '/orgs/' + this.$store.state.usermain.curOrg.id + '/meta_workflows'
    this.$bindAsArray('workflows', database.getRef(ref).orderByChild('archived').equalTo(true));
  },
  computed: {
    filteredData:function(){
      var data = this.workflows
      
      for (var key in data){
        if (!data[key]['filtered']){
          data[key]['nonformattednextdue'] = new Date(data[key]['nextdue']*1000);
        }
        var nextdue_date = data[key]['nonformattednextdue']
        var now = new Date();

        var diffMs = (nextdue_date - now); // milliseconds between now & Christmas
        var diffDays = Math.round(diffMs / 86400000); // days
        var diffHrs = Math.round((diffMs % 86400000) / 3600000); // hours
        var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes

        data[key]['timeleft'] = diffDays + " days, " + diffHrs + " hours, " + diffMins + " minutes"
        data[key]['nextdue'] = this.unix_to_norm(nextdue_date)

        if (data[key]['lastcompleted'] != ''){
          if (!data[key]['filtered']){
            data[key]['nonformattedlastcompleted'] = new Date(data[key]['lastcompleted']*1000);
          }
          var lastcompleted_date = data[key]['nonformattedlastcompleted']

          data[key]['lastcompleted'] = this.unix_to_norm(lastcompleted_date)
        }
        data[key]['filtered'] = true
      
      }

      return data
    }
  },
  methods: {
    unix_to_norm: function(pubDate){
      const weekday = new Array("Sun","Mon","Tue","Wed","Thu","Fri","Sat");
      const monthname = new Array("Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec");

      var hours = pubDate.getHours();
      var minutes = pubDate.getMinutes();
      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? '0'+minutes : minutes;
      var time = hours + ':' + minutes + ' ' + ampm;
      return weekday[pubDate.getDay()] + ' ' 
                + monthname[pubDate.getMonth()] + ' ' 
                + pubDate.getDate() + ', ' 
                + pubDate.getFullYear() + ' at ' 
                + time
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .big-row {
    display:inline;
  }
</style>



// WEBPACK FOOTER //
// ArchivedWorkflows.vue?49766031